// 处理个人设置相关
import i18n, { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import store from '@/renderer/store';
import smh from '@/renderer/scripts/smh';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { IS_BROWSER } from '@/common/constant';
import { CONSTANT_URL } from '@/renderer/scripts/http/index';
import { IS_DEV, IS_TEST } from '@/common/constant/platform';

type Handler = {
  unbindMeeting: () => Promise<void>;
  bindMeeting: () => void;
  unbindTencentDoc: () => Promise<void>;
  bindTencentDoc: () => void;
  unbindWechat: () => Promise<void>;
  unbindSSO: () => Promise<void>;
};
export default function useSetting(): Handler {
  const methods = {
    // 解绑腾讯会议
    async unbindMeeting() {
      try {
        await smh.userAPI.deleteMeetingAuth();
        tips.success(i18n_t('腾讯会议解绑成功'));
        store.commit('SET_BASEINFO', {
          thirdPartyAuthList: {
            ...store.getters.userBaseInfo.thirdPartyAuthList,
            meeting: false,
          },
        });
      } catch (e) {
        tips.error(e as MsgError);
      }
    },
    bindMeeting() {
      // 个人设置里绑定会议时url固定
      let prefix = '';
      if (IS_DEV || IS_TEST) {
        prefix = 'test.';
      }
      const from = IS_BROWSER ? 'web' : 'pc';
      const redirectUrl = `${store.getters.protocol}://${prefix}pan.tencent.com/web/meetingAuth?meetingAction=bindMeeting&from=${from}`;
      const type = IS_BROWSER ? 'location' : undefined;
      dispatchRouter(CONSTANT_URL.meetingAuthUrl + encodeURIComponent(redirectUrl), type);
    },
    // 解绑腾讯文档
    async unbindTencentDoc() {
      // 解绑定文档 功能还没实现后面chrisftian来实现
    },
    // 绑定腾讯文档
    async bindTencentDoc() {
      // 绑定文档 功能还没实现后面chrisftian来实现
    },
    // 解绑微信
    async unbindWechat() {
      try {
        await smh.userAPI.deleteWechatAuth();
        tips.success(i18n_t('微信解绑成功'));
        store.commit('SET_BASEINFO', {
          thirdPartyAuthList: {
            ...store.getters.userBaseInfo.thirdPartyAuthList,
            wechat: false,
          },
        });
      } catch (e) {
        tips.error(e as MsgError);
      }
    },
    // 解绑yufu
    async unbindSSO() {
      try {
        await smh.userAPI.deleteYufuAuth();
        tips.success(i18n_t('SSO解绑成功'));
        store.commit('SET_BASEINFO', {
          thirdPartyAuthList: {
            ...store.getters.userBaseInfo.thirdPartyAuthList,
            yufu: false,
          },
        });
      } catch (e) {
        tips.error(e as MsgError);
      }
    },
  };
  return {
    ...methods,
  };
}
